import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';

interface ITimerProps {
	minutes: number;
	whenExpired?: () => void;
}

const Timer = ({ minutes, whenExpired = () => {} }: ITimerProps) => {
	const end = moment().add(minutes, 'm');
	const [time, setTime] = useState('');
	const timer = useRef();

	const tick = () => {
		const now = moment();
		const diff = moment.duration(end.diff(now));
		const minutesLeft = diff.minutes();
		const secondsLeft = diff.seconds();

		if (diff.asSeconds() > 0) {
			setTime(`${minutesLeft}:${secondsLeft < 10 ? '0' : ''}${secondsLeft}`);
		} else {
			clearInterval(timer.current);
			setTime('00:00');
			whenExpired();
		}
	};

	useEffect(() => {
		tick();
		// @ts-ignore
		timer.current = setInterval(() => tick(), 1000);
		return () => clearInterval(timer.current);
		// eslint-disable-next-line
	}, []);

	return <>{time}</>;
};

export default Timer;
